import Input from 'components/base/Input';
import React from 'react';
import {
  StyledDescription,
  StyledInputWrapper,
  StyledSelectorTitle
} from './ReportedMetricsModal.style';

const UnitInput = ({ modalState, setModalState }) => {
  const MAX_LENGTH = 10;
  return (
    <StyledInputWrapper>
      <StyledSelectorTitle>UNITS</StyledSelectorTitle>
      <StyledDescription>
        Set a unit to specify the measurement or scale of the reported metric
        (e.g. Issues, PRs, Code lines)
      </StyledDescription>
      <Input
        onChange={unit => {
          setModalState({ ...modalState, unit });
        }}
        value={modalState.unit || ''}
        maxLength={MAX_LENGTH}
      />
    </StyledInputWrapper>
  );
};

export default UnitInput;
